import type { ReactElement } from 'react';
import React from 'react';

import { AI_EXPERT_ICONS } from '~/components/Admin/AiExperts/icons';
import BulbIcon from '~/components/AiChat/SideBarDialog/icons/BulbIcon';
import ClaimActionPlanIcon from '~/components/AiChat/SideBarDialog/icons/ClaimActionPlanIcon';
import ComplexityIcon from '~/components/AiChat/SideBarDialog/icons/ComplexityIcon';
import DataExtractionIcon from '~/components/AiChat/SideBarDialog/icons/DataExtractionIcon';
import DataPointIcon from '~/components/AiChat/SideBarDialog/icons/DataPointIcon';
import FinancialIcon from '~/components/AiChat/SideBarDialog/icons/FinancialIcon';
import WarningIcon from '~/components/AiChat/SideBarDialog/icons/WarningIcon';

const SIZE = 22;

// Every AI Expert icon, keyed by its catalog icon key, so expert insights resolve their
// expert's icon. Derived from the single AI_EXPERT_ICONS source — new expert icons are picked
// up automatically, no need to list them here too.
const EXPERT_ICONS_V2: Record<string, ReactElement> = Object.fromEntries(
  AI_EXPERT_ICONS.map(({ key, Icon }) => [key, <Icon key={key} size={SIZE} className="text-blue-700" />])
);

/**
 * New-UI insight icons: the legacy INSIGHTS_ICONS glyphs (keyed by insight_type) plus the AI
 * Expert icons (keyed by the expert's icon key, which the backend stamps onto expert insights'
 * payload). All recolored to blue-700 to sit inside the azure rounded icon box in InsightCardV2.
 */
export const INSIGHT_ICONS_V2: Record<string, ReactElement> = {
  data_extraction: <DataExtractionIcon height={SIZE} width={SIZE} className="fill-blue-700 stroke-white" />,
  data_point: <DataPointIcon height={SIZE} width={SIZE} className="fill-blue-700 stroke-blue-700" />,
  warning: <WarningIcon height={SIZE} width={SIZE} className="fill-blue-700 stroke-white" />,
  general: <BulbIcon height={SIZE} width={SIZE} className="fill-blue-700 stroke-blue-700" />,
  financial: <FinancialIcon height={SIZE} width={SIZE} className="fill-blue-700 stroke-white" />,
  complexity: <ComplexityIcon height={SIZE} width={SIZE} className="fill-blue-700 stroke-blue-700" />,
  claim_action_plan: <ClaimActionPlanIcon height={SIZE} width={SIZE} className="fill-azure-300 stroke-blue-700" />,
  ...EXPERT_ICONS_V2,
};
